import { ApiBase } from "../../../../utils/apiBase";
import { withType } from "../../../../utils/actionOperations";
import { getProjectIdAndOrgId } from '../../../../utils/apiUtils';
import { SETTINGS_PAGE_SECTION } from "../../../../../config/tabConstants";

export const createVisualizationFetchAction = (url, actionTypes) => (payload, cb) => {
    const apiBaseInstance = new ApiBase().instance;
    return (dispatch) => {
        dispatch(
            withType(actionTypes.START, { ...payload })
        );
        return apiBaseInstance
            .post(url, {
                benchmarkFilters: payload, ...getProjectIdAndOrgId(payload), currentTab: SETTINGS_PAGE_SECTION.SETTINGS_SUB_TABS.ADMINISTRATOR
            })
            .then((res) => {
                dispatch(
                    withType(actionTypes.SUCCESS, {
                        data: res.data,
                        payload: payload
                    })
                );
                cb && cb()
            })
            .catch((err) => {
                dispatch(withType(actionTypes.FAIL, { ...err, ...payload }));
                cb && cb()
            });
    };
};
